import React from 'react'
import { Disclosure } from '@headlessui/react'
import type { DisclosureButtonProps, DisclosurePanelProps } from '@headlessui/react'

import { classNames } from '~/helpers/string'

export const Accordion = Disclosure

type AccordionSummaryProps = DisclosureButtonProps<'button'> & {
  isActive?: boolean
}
export const AccordionSummary = (props: AccordionSummaryProps) => {
  const { className, isActive, ...restProps } = props

  return (
    <Disclosure.Button
      as="div"
      role="button"
      tabIndex={0}
      className={(bag) =>
        classNames(
          'group/accordion w-full px-8 py-5',
          bag.open
            ? 'rounded-t-2xl border-l border-r border-t border-brand-primary-300'
            : 'rounded-2xl border border-brand-neutral-300',
          (isActive && bag.open) || (isActive === undefined && bag.open) // If isActive is not specified at all only check bag.open value
            ? 'bg-brand-primary-50'
            : '',
          (typeof className === 'string' ? className : className?.(bag)) || '',
        )
      }
      {...restProps}
    />
  )
}

type AccordionDetailsProps = {
  children: DisclosurePanelProps<'div'>['children']
  className?: string
}
export const AccordionDetails = (props: AccordionDetailsProps) => {
  const { children, className = '' } = props
  return (
    <Disclosure.Panel
      className={classNames('rounded-b-2xl border-b border-l border-r border-brand-primary-300 px-8 py-5', className)}
    >
      {children}
    </Disclosure.Panel>
  )
}

type ArrowProps = {
  open: boolean
  angle?: 'rotate-180' | '-rotate-90'
}

export const Arrow = ({ open, angle = 'rotate-180' }: ArrowProps) => (
  <svg
    className={`text-brand-primary-500 transition-transform ${open ? angle : ''}`}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.43057 8.51192C4.70014 8.19743 5.17361 8.161 5.48811 8.43057L12 14.0122L18.5119 8.43057C18.8264 8.16101 19.2999 8.19743 19.5695 8.51192C19.839 8.82642 19.8026 9.29989 19.4881 9.56946L12.4881 15.5695C12.2072 15.8102 11.7928 15.8102 11.5119 15.5695L4.51192 9.56946C4.19743 9.29989 4.161 8.82641 4.43057 8.51192Z"
      fill="#A761FF"
    />
  </svg>
)
